import axios from 'axios'
import SweetAlert from 'sweetalert2'

const instance = axios.create()

//axios for admin
axios.interceptors.response.use( response => {
    // Do something with response data
   // console.log(response)
    return response
  }, error=> {
    // Do something with response error
   // console.log('error', error.response)
    if(error.response.status == '401'){
       window.location='/admin/login';
       return Promise.reject(error);
    }
    
    return SweetAlert({
            title:'Server Error',
            text:'Please try again later.',
            type:'error'
        }).then(() => {
        window.location = '/admin/dashboard'
        return Promise.reject(error);
    })
  });

//axios1 for public 
const axios1 = axios.create()

axios1.interceptors.response.use( response => {
    // Do something with response data
   // console.log(response)
    return response
  }, error=> {
    // Do something with response error
   // console.log(error)
    if(error.response.status == '404'){
        SweetAlert("Page Not Found", "You will be redirected to Election Result home page." ,"warning")
        .then(() => window.location.href = '/')
        .catch(() => window.location.href = '/');

      return Promise.reject(error);
    }
   // console.log('error', error.response)
    return SweetAlert({
            title:'Server Error',
            text:'Please try again later.',
            type:'error'
        }).then(() => {
        window.location = '/'
        return Promise.reject(error);
    })
  });

//Admin
export function loginAsAdmin(userName, passWord){
    return instance.post(`/account/login`, {UserName: userName, Password:passWord})
           .then(res => {
               return res.status
            })
            .catch(err =>{
                return Promise.reject(err.response.status);
               // return err.response.status
                // if(err.response.status == '404' || err.response.status == '406' ){
                //     return err.response.status
                // }
                // }else if(err.response.status == '404'){
                //      return SweetAlert({
                //         title:'Login Failed',
                //         text:'Username or password is not correct, please correct it and try again.',
                //         type:'error'
                //     }).then(() => {
                //     return window.location = '/admin/login'
                //  })
                // }else if(err.response.status == '406'){
                //     return SweetAlert({
                //         title:'Account Locked Out',
                //         text:'Account is locked out, please try later.',
                //         type:'warning'
                //     }).then(() => {
                //     return window.location = '/admin/login'
                //     })
                // }
                    
                // return SweetAlert({
                //         title:'Server Error',
                //         text:'Please try again later.',
                //         type:'error'
                //     }).then(() => {
                //     return window.location = '/admin/login'
                // })
            })
           
}

export function AdminLogOut(){
    return axios.post(`/account/logOut`)
        .then(res => {
            SweetAlert({
                title:'Log Out',
                text:'You are logged out.',
                type:'warning'
            }).then(() => {
                return window.location = '/admin/login'
            })
        })
}

export function getUserId(){
    return axios.get(`/admin/getUserId`)
    .then(res => (res.data))
    
}

export function getElectionTypeId(){
    return axios.get('/admin/getElectionType')
        .then(res => (res.data))
}


export function getElectionNames(){
    return axios.get('/admin/getElectionNames')
        .then(res => (res.data))
}

export function getImportedElections(){
    return axios.get(`/admin/getImportedElectionNames`)
        .then(res => (res.data))
}

export function uploadFiles(data, config){
    return instance.post(`/admin/uploadFiles`, data, config)
        .then(res => (res.data))
        .catch(err => {
            //console.log(err.response)
            if(err.response.status == '401'){
                 window.location='/admin/login'
                 return Promise.reject(err);
            }else{
                SweetAlert({
                    title:'Upload Failed',
                    text:'Your file uploading failed. Please make sure uploading correct files and try again.',
                    type:'warning'
                    }).then(res => {
                        window.location.reload()
                        return Promise.reject(res);
                })
              //  return err.response
            }
        })
}

export function getVersions(dateId){
    return axios.get(`/admin/getVersions/${dateId}`)
        .then(res => (res.data))
}

export function fetchCityWideResults(id){
    return axios.get(`/cityWideHistory/getCityWideHistory/${id}`)
        .then(res => (res.data))
}

export function fetchWardResults(id, wardnumber){
    return axios.get(`/wardHistory/getWardHistory/${id}/${wardnumber}`)
        .then(res => (res.data))
}

export function fetchPrecinctResults(id, precinctnumber){
    return axios.get(`/precinctHistory/getPrecinctHistory/${id}/${precinctnumber}`)
        .then(res => (res.data))
}

export function getElectionInfo(id){
    return axios.get(`/electionResultsImport/getElectionInfoHistory/${id}`)
        .then(res => (res.data))
}

export function getVoterInfo(id, partyCode){
    return axios.get(`/cityWideHistory/getVoterSummaryInfo/${id}${partyCode ? '/'+partyCode : ''}`)
        .then(res => (res.data))
}

export function getVoterInfoByWard(id, wardnumber, partyCode){
    return axios.get(`/wardHistory/getVoterSummaryInfo/${id}/${wardnumber}${partyCode ? '/'+partyCode : ''}`)
        .then(res => (res.data))
}

export function getVoterInfoByPrecinct(id, precinctnumber, partyCode){
    return axios.get(`/precinctHistory/getVoterSummaryInfo/${id}/${precinctnumber}${partyCode ? '/'+partyCode : ''}`)
        .then(res => (res.data))
}

export function getWardPrecinctHistory(importid){
    return axios.get(`/cityWideHistory/GetWardPrecinctHistory/${importid}`)
    .then(res => (res.data))
}

export function getANCHistory(importId, ancName){
    return axios.get(`/citywidehistory/getCityWideHistory/${importId}/null/true?ancName=${ancName}`)
        .then(res => (res.data))
}

export function getAncList(importId){
    return axios.get(`/citywidehistory/getANCHistory/${importId}`)
        .then(res => (res.data))
}

export function publishResult(importid){
    return axios.post(`/admin/publish/${importid}`)
        .then(res => (res.status))
}

export function unPublishResult(importid){
    return axios.post(`/admin/unpublish/${importid}`)
        .then(res => (res.status))
 }

export function updateLiveStatus(dateId, isLive){
    let path = isLive ? "/admin/UpdateAsNotLiveElection" : "/admin/UpdateAsLiveElection";
    return axios.post(`${path}/${dateId}`)
        .then(res => res.status);
}

export function getMapData(importid, officecode, byward){
    return axios.get(`/mapstatshistory/getMapDetailsHistory/${importid}/${officecode}/${byward}`)
        .then(res => (res.data))
}

// export function createHighlight(boeId, contestNumber, createdBy){
//     return axios.post(`/Admin/createHighlight?boeId=${boeId}&contestNumber=${contestNumber}&createdBy=${createdBy}`)
//         .then(res => {
//             return res
//         })
// }

// export function updateHighlight(boeId, contestNumber){
//     return axios.post(`/Admin/updateElectionHighlight?boeId=${boeId}&contestNumber=${contestNumber}`)
//         .then(res => {
//             return res
//         })
// }

// export function removeHighlight(boeId){
//     return axios.post(`/Admin/removeElectionHighlight?boeId=${boeId}`)
//          .then(res => (res))
// }

export function getPartiesForPrimary(importid){
    return axios.get(`/electionResultsImport/getPartiesForPrimaryHistoryOffice/${importid}`)
        .then(res => (res.data))
}

export function getPartiesForPrimaryStats(importid){
    return axios.get(`/electionResultsImport/getPartiesForPrimaryHistoryStats/${importid}`)
        .then(res => (res.data))
}

export function getOfficeList(importid){
    return axios.get(`/electionResultsImport/getOfficeCodesHistory/${importid}`)
        .then(res => (res.data))
}

export function getPartyColors(){
    return axios.get(`/electionResults/getAllParties`)
         .then(res => (res.data))
}

    
//Public
export function getPublicPartyColors(){
    return axios1.get(`/electionResults/getAllParties`)
         .then(res => (res.data))
}

export function getPublicPartiesForPrimary(resultsid){
    return axios1.get(`/electionResults/getPartiesForPrimaryOffices/${resultsid}`)
        .then(res => (res.data))
}

export function getPublicPartiesForPrimaryStats(resultsid){
    return axios1.get(`/electionResults/getPartiesForPrimaryStats/${resultsid}`)
        .then(res => (res.data))
}


export function getPublicOfficeList(resultsid){
    return axios1.get(`/electionResults/getOfficeCodes/${resultsid}`)
        .then(res => (res.data))
}

export function fetchPublicCityWideResults(id){
    return axios1.get(`/cityWide/getCityWide/${id}`)
        .then(res => (res.data))

}   

export function fetchPublicWardResults(id, wardnumber){
    return axios1.get(`/ward/getWard/${id}/${wardnumber}`)
        .then(res => (res.data))

}

export function fetchPublicPrecinctResults(id, precinctnumber){
    return axios1.get(`/precinct/getPrecinct/${id}/${precinctnumber}`)
        .then(res => (res.data))

}


export function getPublicElectionInfo(resultsid){
    return axios1.get(`/electionResults/getElectionInfo/${resultsid}`)
        .then(res => (res.data))
}


export function getPublicVoterInfo(id, partyCode){
    return axios1.get(`/cityWide/getVoterSummaryInfo/${id}${partyCode ? '/'+partyCode : ''}`)
         .then(res => (res.data))
}

export function getPublicVoterInfoByWard(id, wardnumber, partyCode){
    return axios1.get(`/ward/getVoterSummaryInfo/${id}/${wardnumber}${partyCode ? '/'+partyCode : ''}`)
         .then(res => (res.data))
    
}

export function getPublicVoterInfoByPrecinct(id, precinctnumber, partyCode){
    return axios1.get(`/precinct/getVoterSummaryInfo/${id}/${precinctnumber}${partyCode ? '/'+partyCode : ''}`)
        .then(res => (res.data))
}

export function getPublicWardPrecinct(resultsid){
    return axios1.get(`/cityWide/getWardPrecinct/${resultsid}`)
        .then(res => (res.data))
}

export function getPublicANC(resultsid, ancName){
    return axios1.get(`/citywide/getCityWide/${resultsid}/null/true?ancName=${ancName}`)
        .then(res => (res.data))
}

export function getPublicAncList(resultsid){
    return axios1.get(`/citywide/GetANC/${resultsid}`)
        .then(res => (res.data))
}

export function getPublicMapData(resultsid, officecode, byward){
    return axios1.get(`/mapStats/getMapDetails/${resultsid}/${officecode}/${byward}`)
        .then(res => (res.data))
  
}

export function getPublishedElections(){
    return axios1.get(`/electionResults/getElectionResultsId`)
        .then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/utils/api.js